<h1 class="message-header">{{ content.text }}</h1>

